import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import transformMessage from './messageTransformer';
import useExtendedSubscription from '../../hooks/useExtendedSubscription';
import { ON_MESSAGE_CHANGED } from '../../graphql/messages';
import { showInfoNotification } from '../../actions/notifications';

function GlobalMessages() {
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    useExtendedSubscription(ON_MESSAGE_CHANGED, {
        dataProperty: 'messageChanged',
        onChangeCallback: ({ model: { messageKey, params } }) => {
            const notification = transformMessage(i18n, messageKey, params);
            dispatch(showInfoNotification(notification));
        },
    });
    return null;
}

export default GlobalMessages;
